import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/pages/DashboardPage.vue'),
  },
  {
    path: '/feeds',
    name: 'Feeds',
    component: () => import('@/pages/FeedsPage.vue'),
  },
  {
    path: '/feeds/:id',
    name: 'FeedDetail',
    component: () => import('@/pages/FeedDetailPage.vue'),
  },
  {
    path: '/items',
    name: 'Items',
    component: () => import('@/pages/ItemsPage.vue'),
  },
  {
    path: '/items/:id',
    name: 'ItemDetail',
    component: () => import('@/pages/ItemDetailPage.vue'),
  },
  {
    path: '/workflows',
    name: 'Workflows',
    component: () => import('@/pages/WorkflowsPage.vue'),
  },
  {
    path: '/workflows/:id',
    name: 'WorkflowDetail',
    component: () => import('@/pages/WorkflowDetailPage.vue'),
  },
  {
    path: '/podcasts',
    name: 'Podcasts',
    component: () => import('@/pages/PodcastsPage.vue'),
  },
  {
    path: '/podcasts/:id',
    name: 'PodcastDetail',
    component: () => import('@/pages/PodcastDetailPage.vue'),
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/pages/SearchPage.vue'),
  },
  {
    path: '/activity',
    name: 'Activity',
    component: () => import('@/pages/ActivityPage.vue'),
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: () => import('@/pages/JobsPage.vue'),
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('@/pages/AdminPage.vue'),
    meta: { requiresAdmin: true },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/pages/SettingsPage.vue'),
  },
  {
    path: '/s/:token',
    name: 'SharedItem',
    component: () => import('@/pages/SharedItemPage.vue'),
    meta: { public: true },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/pages/NotFoundPage.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

// Navigation guard: ensure the user has an OIDC session before visiting any
// non-public route, and gate admin-only routes on role.
router.beforeEach(async (to) => {
  if (to.meta.public) {
    return true
  }

  const authStore = useAuthStore()

  // First navigation: kick off the session check if it hasn't happened yet.
  if (authStore.isLoading) {
    await authStore.initialize()
  }

  if (!authStore.isAuthenticated) {
    // No session — bounce to the OIDC login flow. The provider will redirect
    // back to the app frontend URL after auth completes.
    authStore.login()
    return false
  }

  if (to.meta.requiresAdmin && !authStore.isAdmin) {
    return { name: 'Dashboard' }
  }

  return true
})

export default router
